import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import CaiDownload from "../../components/cai-download-cmp/CaiDownload";
import LinearFooterCmp from "../../components/footer/LinearFooter";
import { LNextButton } from "../../components/styled/Button.style";
import { SeparatorLight, Vspace } from "../../components/styled/Separators.style";
import { LPageTitle, LSimpleText } from "../../components/styled/Text.style";
import { LINEAR_BASE_ROUTE, LINEAR_PATHS } from "../../routes/linearRouteConstants";
import { selectCommunicationData } from "../../store";
import { useAppSelector } from "../../store/hooks";
import { TemplateLinearTypeEnum } from "../../types/commonTypes";
import { UserRoleEnum } from "../../types/communication/communicationDataType";
import { composeUrl, requireLinearEndpointReplacement } from "../../utils/utils";
import PageContainerCmp from "../PageContainerCmp";

const RealtimeAccettazioneCaiPageLinear = () => {
    const communicationData = useAppSelector(selectCommunicationData)
    const { communication } = communicationData
    const { userRole, linearControparteInfo, token } = communication
    const { agreeWithCtp } = linearControparteInfo
    const navigate = useNavigate();

    const endpoint = requireLinearEndpointReplacement(window.REACT_APP_VTV_API_ENDPOINT)
    const caiUrl = `${endpoint}/api/realtime/communication/${communication.token}/download-attachment/${communication.file_download_cai_id}`
    const tecnicoUrl = `${endpoint}/api/realtime/communication/${communication.token}/download-attachment/${communication.file_download_tecnico_id}`


    const goToNextStepHandler = () => {
        navigate(composeUrl(token, LINEAR_PATHS.REQUIRE_DOCUMENTS_PAGE, LINEAR_BASE_ROUTE))
    }

    const renderUser1Page = () => (
        <>
            <Vspace />
            <LPageTitle style={{ flex: "unset", color: "#499640", display: "flex" }}>La procedura di firma è andata <br /> a buon fine.</LPageTitle>
            <Vspace qty={2} />
            <LSimpleText>Riceverai per mail copia del documento firmato e report riassuntivo.</LSimpleText>
            <Vspace qty={1} />
            <SeparatorLight style={{ width: "40%", height: "2px", backgroundColor: "#499640" }}></SeparatorLight>
            <Vspace qty={1} />
            {agreeWithCtp ? <><LSimpleText>Cosa succede adesso?</LSimpleText>
                <Vspace qty={2} />
                <LSimpleText style={{ marginLeft: "15px", color: "#575757" }}>
                    <ul>
                        <li><strong>Contatteremo la controparte per sottoporle la Constatazione Amichevole che, eventualmente, potrebbe firmare a sua volta.</strong></li>
                        <br />
                        <li><strong>Ti invitiamo a caricare alcuni documenti integrativi per ultimare la lavorazione del tuo sinistro.</strong></li>
                    </ul>
                </LSimpleText></> : <>
                <LSimpleText><strong>Ti invitiamo a caricare alcuni documenti integrativi per ultimare la lavorazione del tuo sinistro.</strong></LSimpleText>
            </>}
            <Vspace qty={3} />
            <LNextButton onClick={goToNextStepHandler}>CARICARE DOCUMENTI INTEGRATIVI</LNextButton>
            <Vspace qty={2} />
        </>
    );

    const renderCtpPage = () => (
        <>
            <Vspace />
            <LPageTitle style={{ flex: "unset", color: "#499640" }}>La procedura di firma è andata <br /> a buon fine.</LPageTitle>
            <Vspace qty={2} />
            <LSimpleText>Riceverai per sms copia del documento firmato e report riassuntivo.</LSimpleText>
            <Vspace qty={1} />
            <SeparatorLight style={{ width: "40%", height: "2px", backgroundColor: "#499640" }}></SeparatorLight>
            <Vspace qty={1} />
        </>
    );

    const renderAccettazionePage = () => (
        <>
            <Vspace />
            <LSimpleText>Gentile {communication.assic_nome} {communication.assic_cognome},</LSimpleText>
            <Vspace qty={2} />
            <LSimpleText><strong>hai accettato la constatazione amichevole proposta dalla controparte.</strong></LSimpleText>
            <Vspace qty={1} />
            <SeparatorLight style={{ width: "70%", height: "2px", backgroundColor: "#499640" }}></SeparatorLight>
            <Vspace qty={1} />
            <LPageTitle style={{ flex: "unset", color: "#499640" }}>La procedura di firma è andata <br /> a buon fine.</LPageTitle>
            <Vspace qty={2} />
            <LSimpleText style={{ textAlign: "center" }}>Da qui puoi scaricare la copia del <strong color="#3D3D3D">modulo di constatazione amichevole</strong> compilato e firmato, oltre ad un <strong color="#3D3D3D">report tecnico</strong> che certifica il processo di firma digitale</LSimpleText>
            <Vspace qty={2} />
            <CaiDownloadWrapper>
                <CaiDownload companyName="LINEAR" data-testid="cai-url" url={caiUrl} imgPath={'/signed-cai-sample-blur.png'} />
                <CaiDownload companyName="LINEAR" data-testid="tecnico-url" url={tecnicoUrl} imgPath={'/cai-reports-blur.png'} />
            </CaiDownloadWrapper>
        </>
    );

    return (
        <>
            <PageContainerCmp
                routePath={LINEAR_PATHS.LINEAR_REALTIME_ACCETTAZIONE_CAI_PAGE}
                removeNextBtn={true}
            >
                {communication?.type !== TemplateLinearTypeEnum.LINEAR_REALTIME_ACCETTAZIONE_CAI ? (
                    userRole === UserRoleEnum.USER_1 ?
                        renderUser1Page() :
                        renderCtpPage()
                ) :
                    renderAccettazionePage()}
                <LinearFooterCmp />
            </PageContainerCmp>
        </>

    )
}

const CaiDownloadWrapper = styled.div`
    display: flex;
    justify-content: center;
    column-gap: 35px;
`


export default RealtimeAccettazioneCaiPageLinear